import { render } from "@testing-library/react";
import Terria from "../../../lib/Models/Terria";
import ViewState from "../../../lib/ReactViewModels/ViewState";
import WorkflowPanel from "../../../lib/ReactViews/Workflow/WorkflowPanel";
import { jsx as _jsx } from "react/jsx-runtime";
describe("WorkflowPanel", function () {
  let terria;
  let viewState;
  beforeEach(function () {
    terria = new Terria({
      baseUrl: "./"
    });
    terria.configParameters.regionMappingDefinitionsUrl = "./data/regionMapping.json";
    viewState = new ViewState({
      terria,
      catalogSearchProvider: undefined
    });
  });
  it("sets isWorkflowPanelActive when opened", function () {
    expect(viewState.terria.isWorkflowPanelActive).toBe(false);
    render(/*#__PURE__*/_jsx(WorkflowPanel, {
      viewState: viewState,
      title: "test",
      icon: {
        id: "test-icon"
      },
      closeButtonText: "close",
      onClose: () => {},
      children: "children"
    }));
    expect(viewState.terria.isWorkflowPanelActive).toBe(true);
  });
  it("unsets isWorkflowPanelActive sidepanel when closed", async function () {
    const {
      unmount
    } = render(/*#__PURE__*/_jsx(WorkflowPanel, {
      viewState: viewState,
      title: "test",
      icon: {
        id: "test-icon"
      },
      closeButtonText: "close",
      onClose: () => {},
      children: "test"
    }));
    expect(viewState.terria.isWorkflowPanelActive).toBe(true);
    unmount();
    // Wait for the unmount to complete, this will be properly fixed as part of testing environment improvement
    setTimeout(() => {
      expect(viewState.terria.isWorkflowPanelActive).toBe(false);
    }, 0);
  });
});